import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { NavItem } from './components';
import { TopNavWrapperStyled, MobileShow } from './TopNavStyled';
import { api } from 'theSource/utils';
import { GET_TOP_NAV_QUERY_KEY, mapTiles } from './utils';
import { TopNavResponseDto } from './types';

export const TopNav = () => {
  const { t } = useTranslation('pages.home');

  const { data, isLoading } = useQuery<TopNavResponseDto>(
    GET_TOP_NAV_QUERY_KEY,
    () => api.get<TopNavResponseDto>('/pwa/pwa_tiles'),
    { enabled: true } // we no longer check if the source is configured
  );

  const navItems = data && mapTiles(data.data.pwa_tiles);

  if (!isLoading && navItems) {
    return (
      <>
        <MobileShow>
          <h2>{t('quickLinksTitle')}</h2>
        </MobileShow>
        <TopNavWrapperStyled data-testid="top-nav-set">
          {navItems.map((navItem) => (
            <NavItem key={navItem.label} {...navItem} />
          ))}
        </TopNavWrapperStyled>
      </>
    );
  }
};
